const PRODUCTION_HOSTS = new Set(
  (process.env.REACT_APP_PRODUCTION_HOSTS || "dmbwebsolutions.com,www.dmbwebsolutions.com")
    .split(",")
    .map((host) => host.trim().toLowerCase())
    .filter(Boolean)
);

export const deployPlatform = (process.env.REACT_APP_DEPLOY_PLATFORM || "vercel").toLowerCase();

export function isProductionSiteHost(hostname: string): boolean {
  return PRODUCTION_HOSTS.has(hostname.toLowerCase());
}

export function usesPublicApiProxy(): boolean {
  return deployPlatform === "vercel";
}

const apiTarget = (process.env.REACT_APP_DMB_API_TARGET || "local").toLowerCase();

const deploymentApiTargets = new Set([
  "deployment",
  "deploy",
  "production",
  "prod",
]);
const useDeploymentApi = deploymentApiTargets.has(apiTarget);

const localApiUrl =
  process.env.REACT_APP_DMB_API_LOCAL_URL || "http://localhost:5080/api";
const deploymentApiUrl =
  process.env.REACT_APP_DMB_API_DEPLOY_URL ||
  "https://dmbportfolio-api-v5wl.onrender.com/api";

const envApiUrl = process.env.REACT_APP_DMB_API_BASE_URL;

export const dmbApiConfig = {
  // Backward compatible:
  // 1) REACT_APP_DMB_API_BASE_URL (legacy explicit override)
  // 2) REACT_APP_DMB_API_TARGET=local|deploy|deployment|prod|production (preferred)
  dmb_api_url:
    envApiUrl ||
    (useDeploymentApi ? deploymentApiUrl : localApiUrl),
};

export function resolvePublicApiBaseUrl(): string {
  if (
    usesPublicApiProxy() &&
    typeof window !== "undefined" &&
    isProductionSiteHost(window.location.hostname)
  ) {
    return "/api";
  }

  return dmbApiConfig.dmb_api_url;
}

/** Production OAuth start/callback go through the site /api proxy so the browser never hits Render's spin-up page. */
export function resolveOAuthApiBaseUrl(): string {
  if (
    usesPublicApiProxy() &&
    typeof window !== "undefined" &&
    isProductionSiteHost(window.location.hostname)
  ) {
    return `${window.location.origin}/api`;
  }

  return dmbApiConfig.dmb_api_url;
}
